var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.datas, function (items, indexs) {
        return _c(
          "div",
          { key: indexs, staticClass: "container" },
          [
            _c(
              "el-card",
              { staticClass: "card1", attrs: { shadow: "hover" } },
              [
                _c("div", { staticClass: "cardLeft" }, [
                  _c("div", { staticClass: "imgsBox" }, [
                    _c("img", {
                      staticClass: "imgs",
                      attrs: { src: items.imageUrl, alt: "" },
                    }),
                    _c("div", { staticClass: "types" }, [_vm._v(" 专属 ")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "info" },
                    [
                      _c("p", { staticClass: "infoP1" }, [
                        _vm._v(
                          _vm._s(items.nameCn ? items.nameCn : items.nameEn)
                        ),
                      ]),
                      items.addressCn
                        ? _c("p", { staticClass: "infoP2" }, [
                            _c("i", { staticClass: "el-icon-location" }),
                            _vm._v(" " + _vm._s(items.addressCn)),
                          ])
                        : _vm._e(),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            "open-delay": 500,
                            "popper-class": "inquiryDetailTooltip",
                            effect: "dark",
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: { width: "4.5rem" },
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [_vm._v(_vm._s(items.introduction))]
                          ),
                          _c("p", { staticClass: "infoP3" }, [
                            _vm._v(_vm._s(items.introduction)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "cardRight" }, [
                  _c("div", { staticClass: "cardRightTop" }, [
                    _c("div", { staticClass: "cardRightTopLine2" }, [
                      _c("p", { staticClass: "cardRightTopLine2P1" }, [
                        _vm._v(_vm._s(items.score) + "分"),
                        _c("span", [_vm._v("/5分")]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "cardRightBottom" }, [
                    _c("i", {
                      staticClass: "el-icon-caret-bottom icon2",
                      class: items.isShow ? "up" : "down",
                      on: {
                        click: function ($event) {
                          return _vm.launchClick(items)
                        },
                      },
                    }),
                    _c("p", { staticClass: "cardRightBottomP1" }, [
                      _vm._v(_vm._s(_vm.allTotalPrice(items.stockListResults))),
                      _c("span", [_vm._v(_vm._s(items.currency))]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c("el-collapse-transition", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: items.isShow,
                      expression: "items.isShow",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "detailListBox" },
                    [
                      _vm._l(items.stockListResults, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "detailListBoxInfo",
                            style: {
                              marginBottom:
                                items.stockListResults.length - 1 === index
                                  ? 0
                                  : "0.15rem",
                            },
                          },
                          [
                            (item.isCancel === 2 &&
                              _vm.$store.state.orderFlowDirection == 1) ||
                            item.isOrder == 1
                              ? _c("seal", {
                                  attrs: {
                                    text:
                                      item.isOrder == 1 ? "已下单" : "已发送",
                                  },
                                })
                              : _vm._e(),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled:
                                    (item.isCancel === 2 &&
                                      _vm.$store.state.orderFlowDirection ==
                                        1) ||
                                    item.isOrder === 1,
                                  value:
                                    _vm.checked.findIndex(
                                      (n) => n.stockId == item.stockId
                                    ) !== -1,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectChange(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "detailListBoxInfoSpan1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.productNameCn
                                          ? item.productNameCn
                                          : item.productNameEn
                                      )
                                    ),
                                  ]
                                ),
                                item.productDesc
                                  ? _c("span", [
                                      _vm._v(
                                        "（" + _vm._s(item.productDesc) + "）"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            item.isCancel === 2 &&
                            _vm.$store.state.orderFlowDirection == 1 &&
                            item.isOrder !== 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "0.1rem" },
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("cancelClick", item)
                                      },
                                    },
                                  },
                                  [_vm._v("取消发送")]
                                )
                              : _vm._e(),
                            _c(
                              "p",
                              { staticClass: "detailListBoxInfoP1" },
                              [
                                item.recommendation
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "detailListBoxInfoP1Span1",
                                      },
                                      [_vm._v(_vm._s(item.recommendation))]
                                    )
                                  : _vm._e(),
                                item.recommendation
                                  ? _c("el-divider", {
                                      attrs: { direction: "vertical" },
                                    })
                                  : _vm._e(),
                                item.stockDesc
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "detailListBoxInfoP1Span1",
                                      },
                                      [_vm._v(_vm._s(item.stockDesc))]
                                    )
                                  : _vm._e(),
                                item.stockDesc
                                  ? _c("el-divider", {
                                      attrs: { direction: "vertical" },
                                    })
                                  : _vm._e(),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.cancelType == 1
                                        ? "不可取消"
                                        : "有条件退"
                                    ) +
                                      " / Option" +
                                      _vm._s(
                                        _vm._f("dateFormatHms")(item.optionTime)
                                      )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._l(item.priceList, function (q, keys) {
                              return _c(
                                "div",
                                { key: keys, staticClass: "detailBox" },
                                _vm._l(q, function (n, m) {
                                  return _c(
                                    "div",
                                    {
                                      key: m,
                                      staticClass: "detailListBoxInfoP2",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "detailListBoxInfoP2Span1",
                                            staticStyle: {
                                              "margin-right": "0.1rem",
                                            },
                                          },
                                          [
                                            _vm._v(_vm._s(n.startDate)),
                                            n.endDate
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "detailListBoxInfoP2Span3",
                                                  },
                                                  [_vm._v(" 至 ")]
                                                )
                                              : _vm._e(),
                                            n.endDate
                                              ? _c("span", [
                                                  _vm._v(_vm._s(n.endDate)),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.$store.state.orderFlowDirection == 1
                                          ? _c("span", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "detailListBoxInfoP2Span2",
                                                },
                                                [_vm._v("成本：")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "detailListBoxInfoP2Span1",
                                                },
                                                [_vm._v(_vm._s(n.price) + " ")]
                                              ),
                                            ])
                                          : _vm._e(),
                                        n.toCPrice
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "detailListBoxInfoP2Span2",
                                              },
                                              [_vm._v("报价：")]
                                            )
                                          : _vm._e(),
                                        n.toCPrice
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "detailListBoxInfoP2Span1",
                                              },
                                              [_vm._v(_vm._s(n.toCPrice))]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "detailListBoxInfoP2Span1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(n.currency) +
                                                "/" +
                                                _vm._s(n.priceCompany)
                                            ),
                                            n.useTime
                                              ? _c("span", [
                                                  _vm._v(
                                                    "/" +
                                                      _vm._s(n.useTime) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "detailListBoxInfoP2Span1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(n.number) +
                                                _vm._s(n.priceCompany) +
                                                " "
                                            ),
                                            n.useTime
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.state == 0
                                                        ? _vm.days(
                                                            n.startDate,
                                                            n.endDate
                                                          )
                                                        : _vm.days(
                                                            n.startDate,
                                                            n.endDate
                                                          ) + 1
                                                    ) + _vm._s(n.useTime)
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        item.state == 0 &&
                                        n.toCPrice &&
                                        _vm.$store.state.orderFlowDirection == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "detailListBoxInfoP2Span1",
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "detailListBoxInfoP2Span2",
                                                  },
                                                  [_vm._v(" 利润：")]
                                                ),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.saleTotalPrice(
                                                      _vm.days(
                                                        n.startDate,
                                                        n.endDate
                                                      ),
                                                      n
                                                    ) -
                                                      _vm.totalPrice(
                                                        _vm.days(
                                                          n.startDate,
                                                          n.endDate
                                                        ),
                                                        n
                                                      )
                                                  ) + _vm._s(n.currency)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        item.state != 0 &&
                                        n.toCPrice &&
                                        _vm.$store.state.orderFlowDirection == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "detailListBoxInfoP2Span1",
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "detailListBoxInfoP2Span2",
                                                  },
                                                  [_vm._v(" 利润：")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.saleTotalPrice(
                                                        _vm.days(
                                                          n.startDate,
                                                          n.endDate
                                                        ) + 1,
                                                        n
                                                      ) -
                                                        _vm.totalPrice(
                                                          _vm.days(
                                                            n.startDate,
                                                            n.endDate
                                                          ) + 1,
                                                          n
                                                        )
                                                    ) +
                                                    _vm._s(n.currency)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        n.remark
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  item.state == 4
                                                    ? "菜品说明"
                                                    : "备注"
                                                ) +
                                                  "：" +
                                                  _vm._s(n.remark)
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      item.isCancel !== 2 &&
                                      m == 0 &&
                                      _vm.$store.state.orderFlowDirection == 1
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "0.1rem",
                                              },
                                              attrs: {
                                                size: "mini",
                                                type: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.modifyPrice(n)
                                                },
                                              },
                                            },
                                            [_vm._v("修改报价")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            }),
                            _c(
                              "div",
                              { staticClass: "detailListBoxInfoDiv1" },
                              _vm._l(_vm.policylist, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item,
                                    staticClass: "detailListBoxInfoDiv1Btn",
                                  },
                                  [_vm._v(" " + _vm._s(item) + " ")]
                                )
                              }),
                              0
                            ),
                          ],
                          2
                        )
                      }),
                      _c("div", { staticClass: "detailListBoxInfoDiv2" }, [
                        _c("i", {
                          staticClass: "el-icon-caret-top icon3",
                          on: {
                            click: function ($event) {
                              items.isShow = false
                            },
                          },
                        }),
                      ]),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ],
          1
        )
      }),
      _c("modifyQuotationPopup", {
        ref: "modifyQuotationPopup",
        on: { updatePrice: _vm.updatePrice },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }